const TEST_MODE = false;
const PROD_URL = 'https://server.mediopuntoapp.net';
const TEST_URL = 'http://localhost:';

const DEPLOYED = {
    users_api: true,
    configuration_api: true,
    menu_api: true,
    management_api: true,
    pedidos_api: true,
    clients_api: true,
    payments_api: true
};

const getApiHost = (deployed: boolean, localPort: string) =>
    !deployed || TEST_MODE ? TEST_URL + localPort : PROD_URL;

const MANAGEMENT_API = `${getApiHost(DEPLOYED.management_api, '5004')}/management_api`;
const PEDIDOS_API = `${getApiHost(DEPLOYED.pedidos_api, '5005')}/pedidos_api`;

const APIS = {
    users_api: `${getApiHost(DEPLOYED.users_api, '5001')}/users_api`,
    configuration_api: MANAGEMENT_API,
    menu_api: PEDIDOS_API,
    management_api: MANAGEMENT_API,
    pedidos_api: PEDIDOS_API,
    clients_api: MANAGEMENT_API,
    payments_api: PEDIDOS_API
};

export const NAMESPACES = {
    users_api: {
        auth: APIS.users_api+'/auth',
        users: APIS.users_api+'/users',
        user_invitations: APIS.users_api+'/user_invitations',
        support_tickets: APIS.users_api+'/support_tickets',
        ticket_threads: APIS.users_api+'/ticket_threads',
        user_notifications: APIS.users_api+'/user_notifications',
        user_permissions: APIS.users_api+'/user_permissions',
    },

    configuration_api: {
        third_party_providers: APIS.configuration_api+'/third_party_providers',
        countries_taxes: APIS.configuration_api+'/countries_taxes',
        global_bill_category: APIS.configuration_api+'/global_bill_category',
        companies: APIS.configuration_api+'/companies',
        languages: APIS.configuration_api+'/languages',
        monedas: APIS.configuration_api+'/monedas',
        notifications: APIS.configuration_api+'/notifications',
        pedidos_type: APIS.configuration_api+'/pedidos_type',
        places: APIS.configuration_api+'/places',
        planes: APIS.configuration_api+'/planes',
        roles: APIS.configuration_api+'/roles',
        terminal_types: APIS.configuration_api+'/terminal_types',
        timezones: APIS.configuration_api+'/timezones',
        unidades_medida: APIS.configuration_api+'/unidades_medida',
        application_permissions: APIS.configuration_api+'/application_permissions',
        ticket_severity: APIS.configuration_api+'/ticket_severity',
        ticket_category: APIS.configuration_api+'/ticket_category',
        caja_movement_types: APIS.configuration_api+'/caja_movement_types',
        account_creation_codes: APIS.configuration_api+ '/account_creation_codes',
        mp_base_puestos: APIS.configuration_api+'/mp_base_puestos',
        local_plans: APIS.configuration_api+'/local_plans',
        local_plan_payments: APIS.configuration_api+'/local_plan_payments',

    },
    menu_api: {
        menu_category_types: APIS.menu_api+'/menu_category_types',
        categories: APIS.menu_api+'/categories',
        menus: APIS.menu_api+'/menus',
        items: APIS.menu_api+'/items',
        ingredients: APIS.menu_api+'/ingredients',
        selection_groups: APIS.menu_api+'/selection_groups',
        selection_modifiers: APIS.menu_api+'/selection_modifiers',
        brands: APIS.menu_api+'/brands',
        item_stats: APIS.menu_api+'/item_stats',
        price_changes: APIS.menu_api+'/price_changes',
    },
    management_api: {
        feature_rollout: MANAGEMENT_API+'/feature_rollout',
        settings_delegation: MANAGEMENT_API+'/settings_delegation',
        storage_unit_movements: APIS.management_api+'/storage_unit_movements',
        user_salaries: APIS.management_api+'/user_salaries',
        local_expenses_categories: APIS.management_api+'/local_expenses_categories',
        local_expenses: APIS.management_api+'/local_expenses',
        local_bill_category: APIS.management_api+'/local_bill_category',
        local_bills: APIS.management_api+'/local_bills',
        local_configurations: APIS.management_api+'/local_configurations',
        locales: APIS.management_api+'/locales',
        mesas: APIS.management_api+'/mesas',
        objetos: APIS.management_api+'/objetos',
        providers: APIS.management_api+'/providers',
        puestos: APIS.management_api+'/puestos',
        salones: APIS.management_api+'/salones',
        terminals: APIS.management_api+'/terminals',
        workstations: APIS.management_api+'/workstations',
        mesas_info: APIS.management_api+'/mesas_info',
        locales_caja_management: APIS.management_api+'/locales_caja_management',
        sales_statistics: APIS.management_api+'/sales_statistics',
        local_sessions: APIS.management_api+'/local_sessions',
        reservations_configuration: APIS.management_api+'/reservations_configuration',
        caja_session_records: APIS.management_api+'/caja_session_records',
        utilities: APIS.management_api+'/utilities',
        utility_categories: APIS.management_api+'/utility_categories',
        storage_units: APIS.management_api+'/storage_units',
        stock_management: APIS.management_api+'/stock_management',
        local_site_configuration: APIS.management_api+'/local_site_configuration',
        invoices: APIS.management_api+'/invoices',
        ingredient_purchases: APIS.management_api+'/ingredient_purchases',
        third_party_providers_config: APIS.management_api+'/third_party_providers_config',
        simple_api_config: APIS.management_api+'/simple_api_config',
    },
    pedidos_api: {
        pedidos: APIS.pedidos_api+'/pedidos',
        comandas: APIS.pedidos_api+'/comandas',
        pedidos_modifications: APIS.pedidos_api+'/pedidos_modifications',
        rappi: APIS.pedidos_api+'/rappi',
        pedidos_ya: APIS.pedidos_api+'/pedidos_ya',
        delivery_apps: APIS.pedidos_api+'/delivery_apps',
        pedido_groups: APIS.pedidos_api+'/pedido_groups',
    },
    clients_api:{
        clients: APIS.clients_api+'/clients',
        client_reviews: APIS.clients_api+'/client_reviews',
        client_reservations: APIS.clients_api+'/client_reservations',
        marketing: APIS.clients_api+'/marketing',
        client_waitlist: APIS.clients_api+'/client_waitlist',
        memberships: APIS.clients_api+'/memberships',
        local_clients: APIS.clients_api+'/local_clients',
        client_receipts: APIS.clients_api+'/client_receipts',
    },
    payments_api: {
        payment_coupons: APIS.payments_api+'/payment_coupons',
        payment_discounts: APIS.payments_api+'/payment_discounts',
        payment_types: APIS.payments_api+'/payment_types',
        client_coupons: APIS.payments_api+'/client_coupons',
        payment_receipts: APIS.payments_api+'/payment_receipts',
        caja_movements: APIS.payments_api+'/caja_movements',
        payment_transactions: APIS.payments_api+'/payment_transactions',
        tip_management: APIS.payments_api+'/tip_management',
        dte: APIS.payments_api+'/dte',
        cache: APIS.payments_api+'/cache',
    }
}